// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__4LuqD","clinicsSelect":"TableHeading_clinicsSelect__31vr1"};